import { render, staticRenderFns } from "./applyShopEdit.vue?vue&type=template&id=ddc45a76&scoped=true"
import script from "./applyShopEdit.vue?vue&type=script&lang=js"
export * from "./applyShopEdit.vue?vue&type=script&lang=js"
import style0 from "./applyShopEdit.vue?vue&type=style&index=0&id=ddc45a76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc45a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddc45a76')) {
      api.createRecord('ddc45a76', component.options)
    } else {
      api.reload('ddc45a76', component.options)
    }
    module.hot.accept("./applyShopEdit.vue?vue&type=template&id=ddc45a76&scoped=true", function () {
      api.rerender('ddc45a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/shopApply/applyShopEdit.vue"
export default component.exports